import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRefs, useContext } from '@nuxtjs/composition-api';
import type { MetaUser } from "~/core/models/MetaUser.js";
import { ACTIONS as SIDEBAR_ACTIONS, GETTERS as SIDEBAR_GETTERS } from '~/store/affility/layout/sidebar/names';

interface Props {
    user: MetaUser;
}
export default /*#__PURE__*/_defineComponent({
  __name: 'Desktop',
  props: {
    user: { default: null }
  },
  setup(__props: any) {

const props = __props as { user: MetaUser };

;



const { user } = toRefs(props);

const store = useContext().store;

const sidebarItems = computed(() => store.getters[`affility/layout/sidebar/${SIDEBAR_GETTERS.CONFIG}`]);

const openedSubMenuObject = computed(() => store.getters[`affility/layout/sidebar/${SIDEBAR_GETTERS.OPENED_SUBMENU}`]);
const activeItemPath = computed(() => store.getters[`affility/layout/sidebar/${SIDEBAR_GETTERS.ACTIVE_ITEM_PATH}`]);

const closeSubMenu = store.dispatch.bind(null, `affility/layout/sidebar/${SIDEBAR_ACTIONS.CLOSE_SUBMENU}`);
const openSubMenu = store.dispatch.bind(null, `affility/layout/sidebar/${SIDEBAR_ACTIONS.OPEN_SUBMENU}`);

let timeout = ref<ReturnType<typeof setTimeout>>(null);

const delayedOpenSubMenu = (item = openedSubMenuObject.value) => {
    clearTimeout(timeout.value);
    timeout.value = setTimeout(openSubMenu, 300, item);
};

const delayedCloseSubMenu = () => {
    clearTimeout(timeout.value);
    timeout.value = setTimeout(closeSubMenu, 300);
};


return { __sfc: true,props, user, store, sidebarItems, openedSubMenuObject, activeItemPath, closeSubMenu, openSubMenu, timeout, delayedOpenSubMenu, delayedCloseSubMenu }
}

})